var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlinko({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 512 512",
    fill: "#6e7589",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256.001 140.352C288.001 140.352 312.243 115.14 312.243 84.1096C312.243 75.3824 310.304 66.6551 306.425 58.8976C305.455 57.9279 293.819 26.8977 256.001 26.8977C219.153 26.8977 206.547 56.9582 204.607 58.8976C200.728 66.6551 198.789 74.4127 198.789 83.1399C198.789 114.17 224.971 140.352 256.001 140.352Z",
    fill: "#6e7589"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M189.093 255.745C221.093 255.745 245.335 230.533 245.335 199.503C245.335 168.473 220.123 143.261 189.093 143.261C167.76 143.261 149.335 154.897 139.638 172.352V173.321C119.275 215.018 149.335 255.745 189.093 255.745Z",
    fill: "#6e7589"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M265.697 199.503C265.697 230.533 290.909 255.745 321.94 255.745C353.939 255.745 378.182 230.533 378.182 199.503C378.182 168.473 352.97 143.261 321.94 143.261C291.879 142.291 265.697 168.473 265.697 199.503Z",
    fill: "#6e7589"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M389.818 372.109C420.88 372.109 446.061 346.928 446.061 315.866C446.061 284.805 420.88 259.624 389.818 259.624C358.757 259.624 333.576 284.805 333.576 315.866C333.576 346.928 358.757 372.109 389.818 372.109Z",
    fill: "#6e7589"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M256.002 372.109C287.064 372.109 312.244 346.928 312.244 315.866C312.244 284.805 287.064 259.624 256.002 259.624C224.94 259.624 199.76 284.805 199.76 315.866C199.76 346.928 224.94 372.109 256.002 372.109Z",
    fill: "#6e7589"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M179.395 315.866C179.395 284.836 154.183 259.624 123.152 259.624C92.1222 259.624 66.9102 284.836 66.9102 315.866C66.9102 346.897 92.1222 372.109 123.152 372.109C154.183 372.109 179.395 346.897 179.395 315.866Z",
    fill: "#6e7589"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M455.758 487.502C486.82 487.502 512 462.322 512 431.26C512 400.198 486.82 375.018 455.758 375.018C424.696 375.018 399.516 400.198 399.516 431.26C399.516 462.322 424.696 487.502 455.758 487.502Z",
    fill: "#6e7589"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M322.91 487.502C353.972 487.502 379.152 462.322 379.152 431.26C379.152 400.198 353.972 375.018 322.91 375.018C291.849 375.018 266.668 400.198 266.668 431.26C266.668 462.322 291.849 487.502 322.91 487.502Z",
    fill: "#6e7589"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M189.092 375.018C158.062 375.018 132.85 400.23 132.85 431.26C132.85 462.29 158.062 487.502 189.092 487.502C221.092 487.502 245.334 462.29 245.334 431.26C246.304 400.23 220.122 375.018 189.092 375.018Z",
    fill: "#6e7589"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2442 487.502C87.3059 487.502 112.486 462.322 112.486 431.26C112.486 400.198 87.3059 375.018 56.2442 375.018C25.1825 375.018 0.00195312 400.198 0.00195312 431.26C0.00195312 462.322 25.1825 487.502 56.2442 487.502Z",
    fill: "#6e7589"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlinko);
export default __webpack_public_path__ + "static/media/Plinko.e361a938371bf10fd687ddcfb7a858d4.svg";
export { ForwardRef as ReactComponent };